import { render, staticRenderFns } from "./treaseure-aztec.vue?vue&type=template&id=8f386516&scoped=true"
import script from "./treaseure-aztec.vue?vue&type=script&lang=js"
export * from "./treaseure-aztec.vue?vue&type=script&lang=js"
import style0 from "./treaseure-aztec.vue?vue&type=style&index=0&id=8f386516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f386516",
  null
  
)

export default component.exports